import { render, staticRenderFns } from "./ring.vue?vue&type=template&id=e99b9e4c&scoped=true"
import script from "./ring.vue?vue&type=script&lang=js"
export * from "./ring.vue?vue&type=script&lang=js"
import style0 from "./ring.vue?vue&type=style&index=0&id=e99b9e4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99b9e4c",
  null
  
)

export default component.exports